var mia = mia || {};
mia.preview = mia.preview || {};

mia.preview.api = {

    messageKeys: {
        initialized: 1,
        sendLatestData: 1001,

    },
    domainCache: null,
    parameterCache: null,
    /**
     * Retrieves all url parameters. Which means
     * that params that have been set specifically for
     * mia.preview.api will also be present.
     *
     * currently, these are:
     * -  previewMode ("enabled")
     *
     */
    getUrlParams: function () {

        if (mia.preview.api.parameterCache == null) {

            var parameters = {};
            mia.preview.api.parameterCache = parameters;

            location.search.substr(1).split("&").forEach(function (item) {
                var s = item.split("="),
                    k = s[0],
                    v = s[1] && decodeURIComponent(s[1]);

                (k in parameters) ? parameters[k].push(v) : parameters[k] = [v];

            });
        }
        return mia.preview.api.parameterCache;
    },

    /**
     * returns true if the previewmode is enabled 
     * (through a query string parameter, read with
     * getUrlParams)
     */
    isPreviewModeEnabled: function () {

        var p = mia.preview.api.getUrlParams();
        return (p.previewMode && p.previewMode == "enabled");
    },

    /**
     * triggers a get data event from api. Can be called at any time
     * if no data is available, returns false. else returns an object
     * with data properties.
     */
    getData: function () {

        parent.postMessage(
          {
              key: mia.preview.api.messageKeys.sendLatestData,
              data: null
          }, mia.preview.api.domainCache);
    },

    /**
     * call to initalize the listener and receive updates.
     * the domain property is used for security, and must match
     * the domain as specified on the application setup in MIA.
     * the eventListener will receive the events from the post message.
     */
    init: function (domain, eventListener) {

        mia.preview.api.domainCache = domain;

        // note that we add our own listener first to process
        // the event data, and then return it to the applications
        // event listener.
        window.addEventListener("message", function (event) {

            // todo: add logic to use origin for security reasons..
            var origin = event.origin || event.originalEvent.origin;
            // For Chrome, the origin property is in the event.originalEvent object.
            //if (origin !== "http://example.org:8080")


            // todo: do we need additional parsing of data?
            var data = event.data || event.originalEvent.data;
            eventListener(data);

        }, false);


        parent.postMessage(
           {
               key: mia.preview.api.messageKeys.initialized,
               data: null
           }, mia.preview.api.domainCache);

        //todo: add overload to init method to enable or disable automatic
        // get data on init.. 
        setTimeout(mia.preview.api.getData, 200);   // set small timeout to avoid collisions

    },
};

export default mia;